<template>
	<layout-admin-auto-loading class="admin-disease-names-list" :loader="getDiseaseNames" :loading="loading" :finished="finished" :error="error">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<h1 slot="header">{{ title }}</h1>
		<div slot="body" v-if="!error">
			<admin-data-table :finished="finished" :table_columns="table_columns" :table_rows="table_rows"/>
		</div>
	</layout-admin-auto-loading>
</template>

<script>
import LayoutAdminAutoLoading from '../LayoutAdminAutoLoading'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
import AdminDataTable from '../AdminDataTable'
export default {
	components: {
		LayoutAdminAutoLoading,
		AdminBreadcrumbs,
		AdminDataTable
	},
	data () {
		return {
			title: 'Disease Names List',
			loading: false,
			error: null,
			data: [],
			finished: false,
			limit: 20,
			table_columns: [
				{
					label: '#',
					field: 'id',
					width: '75px'
				},
				{
					label: 'Name',
					field: 'name'
				}
			]
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: this.title
				}
			]
		},
		offset () {
			return this.data.length
		},
		table_rows () {
			return this.data.map(row => {
				return {
					columns: [
						{ field: 'id', value: row.id },
						{ field: 'name', value: row.name }
					]
				}
			})
		}
	},
	methods: {
		getDiseaseNames () {
			this.loading = true
			this.$api.profile.diseases.admin.getAll(this, this.offset, this.limit).then(response => {
				this.$log.info('admin', 'profile.diseases.admin.getAll OK', response)()
				if (response.body.length) {
					this.data = this.data.concat(response.body)
				}
				if (!response.body.length || response.body.length < this.limit) {
					this.finished = true
				}
			}).catch(errors => {
				this.$log.error('admin', 'profile.diseases.admin.getAll ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.loading = false
			})
		}
	},
	beforeCreate () {
		this.$title('Disease Names')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/diseasenames/DiseaseNamesList.vue